import React from 'react'
import Navbar from '../components/Navbar';
import Footer from "../components/Footer";
import HeroImg2 from "../components/HeroImg2";
import AboutContent from '../components/AboutContent';
import WhatsAppButton from '../components/WhatsAppButton';

const About = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg2 heading="ABOUT." text="Here you will find the company information" />
      <AboutContent/>
      <WhatsAppButton />
      <Footer/>

    </div>
  )
}

export default About